<template>
    <div>

        <div class="grid grid-cols-5 w-full">

            <div class="col-span-2 p-2">
                <div class="flex-grow items-center ">
                    <div class="">
                        <div class="border-b border-gray-300 h-4">
                        </div>
                        <p class="flex justify-center items-center h-8 -mt-4">
                            <span class="px-2 bg-white font-medium text-sm text-gray-700"> Cashback Rules</span>
                        </p>
                    </div>
                    <CustomButton text="Add rule" small icon="Plus" type="default"
                        @click="offerRequest.cashbackRules.push(newRule)" />
                </div>

                <div v-for="cashbackRule, index in offerRequest.cashbackRules" :key="index"
                    class="border-2 rounded-xl mt-3 bg-gray-50 p-2">
                    <div class="flex justify-between m-1">
                        <p class=" font-medium">Rule {{ index + 1 }}</p>
                        <div v-if="index != 0"  @click="offerRequest.cashbackRules.splice(index,1)" class="w-6 ml-3 h-6 rounded-md hover:text-red-600 cursor-pointer ">
                            <LucideIcon name="Trash2" :size="20" :stroke-width="1.7" />
                        </div>

                    </div>
                    <div class="p-2 border-2 rounded-xl border-gray-200 bg-white">
                        <div class="flex justify-start m-1">
                            <p class="text-sm font-medium">Customer segmentation</p>
                        </div>
                        <div class="flex justify-between gap-y-2 m-1 mb-2">
                            <div class="w-4/5 mr-1">
                                <CustomSelect :pre-select="offerRequest.cashbackRules[index].customerType" v-model="offerRequest.cashbackRules[index].customerType" :options="customerType"
                                    label="Customer type" />
                            </div>
                            <div class="w-4/5 mr-1">
                                <CustomSelect pre-select="MULTIUSE" :options="offerUsageType"
                                    label="Offer usage type" />
                            </div>
                        </div>
                    </div>
                    <div class="flex-grow p-2 items-center mb-2">
                        <div class="">
                            <div class="border-b border-gray-300 h-4">
                            </div>
                            <p class="flex justify-center items-center h-8 -mt-4">
                                <span class="px-2 bg-gray-50 font-medium text-sm text-gray-700">Conditions</span>
                            </p>
                        </div>
                        <CustomButton text="Add condition" small icon="Plus" type="default"
                            @click="offerRequest.cashbackRules[index].conditions.push(newCondition)" />
                    </div>
                    <div v-for="condition, index2 in offerRequest.cashbackRules[index].conditions" :key="index2"
                        class="p-2 rounded-xl border-2 border-gray-200 bg-white mb-2">
                        <div class="flex justify-between m-1">
                            <p class="text-sm font-medium">Condition {{ index2 + 1 }}</p>
                            <div v-if="index2 != 0" @click="offerRequest.cashbackRules[index].conditions.splice(index,1)" class="w-6 ml-3 h-6 rounded-md hover:text-red-600 cursor-pointer ">
                                <LucideIcon name="Trash2" :size="20" :stroke-width="1.7" />
                            </div>
                        </div>
                        <div class="m-1 mb-4">
                            <p class="text-sm font-medium"> Spend rule</p>
                            <div>
                                <CustomSelect :pre-select="offerRequest.cashbackRules[index].conditions[index2].type" v-model="offerRequest.cashbackRules[index].conditions[index2].type" :options="offerCondition"
                                    label="Condition type" />
                            </div>
                            <div v-if="condition.type == 'GREATER_THAN'" class="flex justify-between">
                                <CustomInput v-model="offerRequest.cashbackRules[index].conditions[index2].lowerBound" class="w-full mt-1" type="number"
                                    placeholder="20" label="Transaction amount (Lower bound)" />

                            </div>
                            <div v-if="condition.type == 'LESS_THAN'" class="flex justify-between">
                                <CustomInput v-model="offerRequest.cashbackRules[index].conditions[index2].upperBound" class="w-full mt-1" type="number"
                                    placeholder="20" label="Transaction amount (Upper bound)" />

                            </div>

                            <div v-if="condition.type == 'BETWEEN'" class=" flex justify-between items-center mr-1">
                                <CustomInput v-model="offerRequest.cashbackRules[index].conditions[index2].lowerBound" class="w-full mt-1" type="number"
                                    placeholder="20" label="Lower bound" />

                                <CustomInput v-model="offerRequest.cashbackRules[index].conditions[index2].upperBound" class="w-full mt-1" type="number"
                                    placeholder="20" label="Upper bound" />
                            </div>

                        </div>

                        <div class="border-t-2 justify-start m-1 ">
                            <p class="text-sm font-medium mt-4"> Reward</p>
                            <div class="flex justify-between">
                                <div class="mr-1">
                                    <CustomSelect :pre-select="offerRequest.cashbackRules[index].conditions[index2].value.type" v-model="offerRequest.cashbackRules[index].conditions[index2].value.type" :options="rewardType" label="Type" />
                                </div>
                                <div class=" mr-1">
                                    <CustomInput v-model="offerRequest.cashbackRules[index].conditions[index2].value.totalValue" class="w-full mt-1" type="number"
                                        placeholder="20" label="Value" />
                                </div>
                                <div>
                                    <CustomInput v-if="offerRequest.cashbackRules[index].conditions[index2].value.type == 'PERCENTAGE_MAX'"
                                        v-model="offerRequest.cashbackRules[index].conditions[index2].value.maximum" class="w-full mt-1" type="number"
                                        placeholder="20" label="Fixed maximum" />
                                </div>
                            </div>
                            <div class="flex items-bottom justify-between mt-4"
                                v-if="offerRequest.cashbackRules[index].conditions[index2].fixedDistributorCommission == true">
                                <div class="w-4/5 mr-1">
                                    <CustomInput  v-model="offerRequest.cashbackRules[index].conditions[index2].value.endUserValue" class="w-full mt-1" type="number" placeholder="20"
                                        label="End user cashback" />
                                </div>
                                <div class="w-4/5 mr-1">
                                    <CustomInput  v-model="offerRequest.cashbackRules[index].conditions[index2].value.clientValue" class="w-full mt-1" type="number" placeholder="20"
                                        label="Your commission" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end m-1 mt-4">
                    <CustomButton class="w-full" :disabled="!validForm" text="Add offer" type="action"
                        @click="$emit('offerCashbackSumbit',offerRequest)" />
                </div>


            </div>
            <div class="col-span-3 p-2 justify-center">
                <div class="bg-[#F5F2FB] px-3 py-4 rounded-lg bg-opacity-60 grid gap-2 overflow-x-auto">
                    <div class="grid gap-2" v-if="offerInformationData.offerName != ''">
                    <div 
                        class="flex justify-start items-center px-1 py-1 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300">
                        <img class="object-contain w-[50px] h-[50px] rounded-lg border border-gray-200 bg-white"
                            :src="offerInformationData.offerLogo" />
                        <div class="">
                            <p class="font-semibold text-lg">{{ offerInformationData.offerName }}</p>
                        </div>
                    </div>

                    <div class="p-3 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300">
                        <p class="text-sm font-medium mb-1">Offer Data</p>

                        <div class="px-1 py-1 text-sm ">
                            <div class="flex justify-between">
                                <p>Supplier Id:</p>
                                <p>{{ offerInformationData.supplierId }}</p>
                            </div>
                            <div class="flex justify-between">
                                <p>Offer Type:</p>
                                <p>{{ offerInformationData.offerType }}</p>
                            </div>
                            <div class="flex justify-between">
                                <p>Country avaliable:</p>
                                <p>{{ offerInformationData.country }}</p>
                            </div>
                            <div class="flex justify-between">
                                <p>Currency:</p>
                                <p>{{ offerInformationData.currency }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="p-3 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300"
                        v-if="offerInformationData.cashbackRules[0].customerType != ''">
                        <EasyDataTable :table-min-height="0" :headers="rulesHeader" :items="offerInformationData.cashbackRules"
                            :loading="loading" :hide-footer="true" :no-hover="true">
                            <template #loading>
                                <div class="p-4 w-full flex justify-center">
                                    <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                        </path>
                                    </svg>
                                </div>
                            </template>
                            <template #empty-message>
                                <div class="flex justify-center py-4">
                                    <div
                                        class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                        <p class="text-sm mr-2">No results</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <template #header-action="header">
                                <div class="w-full text-right">
                                    {{ header.text }}
                                </div>
                            </template>
                            <template #item-usetype>
                                <StatusPill text="Multi-use" colour="blue" />
                            </template>
                            <template #item-customertype="customerType">
                                <StatusPill :text="customerType.customerType" colour="blue" />
                            </template>
                            <template #item-fixedDistributorCommission="val">
                                <div v-if="val.conditions.length === 1" class="">
                                    <StatusPill v-if="val.conditions[0].fixedDistributorCommission" text="True"
                                        colour="green" />
                                    <StatusPill v-else text="False" colour="red" />
                                </div>
                            </template>
                            <template #item-userCashback="val">
                                <CashbackPill v-if="val.conditions.length === 1"
                                    :text="val.conditions[0].value.endUserValue" :type="val.conditions[0].value.type"
                                    currency="GBP" />
                            </template>
                            <template #item-publisherCashback="val">
                                <CashbackPill v-if="val.conditions.length === 1"
                                    :text="val.conditions[0].value.clientValue" :type="val.conditions[0].value.type"
                                    currency="GBP" />
                            </template>
                            <template #item-cashbackType="val">
                                <StatusPill v-if="val.conditions.length === 1" :text="val.conditions[0].value.type"
                                    colour="blue" />
                            </template>
                            <template #item-conditions="val">
                                <div v-if="val.conditions.length === 1" class="">
                                    <div
                                        class="bg-blue-100 border border-blue-400 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full text-nowrap w-min">
                                        <span v-if="val.conditions[0].type === 'GREATER_THAN'">
                                            Greater than £
                                        </span>
                                        <span v-if="val.conditions[0].type === 'LESS_THAN'">
                                            Less than £
                                        </span>
                                        <span v-if="val.conditions[0].type === 'BETWEEN'">
                                            Between £
                                        </span>
                                        {{ val.conditions[0].lowerBound }}
                                        <span v-if="val.conditions[0].type === 'BETWEEN'">
                                            and £
                                        </span>
                                        {{ val.conditions[0].upperBound }}
                                    </div>
                                </div>
                            </template>
                        </EasyDataTable>
                    </div>
                    <div class="p-3 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300">
                        <p class="text-sm font-medium mb-1">Description</p>
                        <p class="text-sm">{{ offerInformationData.offerDescription }}</p>
                    </div>
                    <div class="p-3 gap-2 w-full bg-white shadow-sm rounded-xl border border-gray-300">
                        <p class="text-sm font-medium mb-1">Where to shop:</p>
                        <EasyDataTable :headers="headersTable1" :items="displayChannels"
                            :loading="loading" v-model:server-options="serverOptions"
                            :server-items-length="serverItemsLength" :hide-footer="false" :no-hover="true">
                            <template #loading>
                                <div class="p-4 w-full flex justify-center">
                                    <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                        fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                            stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                        </path>
                                    </svg>
                                </div>
                            </template>
                            <template #empty-message>
                                <div class="flex justify-center py-4">
                                    <div
                                        class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                        <p class="text-sm mr-2">No results</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                            stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                        </svg>
                                    </div>
                                </div>
                            </template>
                            <template #header-action="header">
                                <div class="w-full text-right">
                                    {{ header.text }}
                                </div>
                            </template>


                        </EasyDataTable>
                    </div>
                </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import CustomSelect from "../inputs/CustomSelect.vue";
import LucideIcon from "@/components/LucideIcon.vue";
import StatusPill from "@/components/StatusPill.vue";
import CashbackPill from "@/components/CashbackPill.vue";


export default {
    name: "offer-mapping",
    components: {
        CustomInput,
        CustomButton,
        CustomSelect,
        LucideIcon,
        CashbackPill,
        StatusPill
    },
    props: {
        retailerData: {
            type: Object

        },
        offerInformationData: {
            type: Object
        },

    },
    data() {
        return {

            rulesHeader: [
                { text: "Customer type", value: "customerType" },
                { text: "Use Type", value: "offerUsageType" },
                { text: "Cashback Type", value: "cashbackType" },

                { text: "User Cashback", value: "userCashback" },
                { text: "Publisher Cashback", value: "publisherCashback" },

                { text: "Condition", value: "conditions" },
            ],


            newRule: {
                customerType: "",
                lapsedInDays: null,
                conditions: [
                    {
                        type: "",
                        lowerBound: null,
                        upperBound: null,
                        value: {
                            type: "",
                            totalValue: undefined,
                            maxAvailableValue: undefined,
                            maximum: undefined,
                            endUserValue: undefined,
                            supplierValue: 0,
                            boogiValue: 0,
                            clientValue: undefined
                        },
                        fixedDistributorCommission: true

                    }
                ]
            },
            newCondition: {
                type: "",
                lowerBound: "",
                upperBound: "",
                value: {
                    type: "",
                    totalValue: undefined,
                    maximum: undefined,
                    endUserValue: undefined,
                    supplierValue: 0,
                    boogiValue: 0,
                    clientValue: undefined
                },
                fixedDistributorCommission: true
            },

            offerRequest: {
                cashbackRules: JSON.parse(JSON.stringify(this.offerInformationData.cashbackRules))
            },

            trueOrFalse: [
                { "id": true, "text": "Yes" },
                { "id": false, "text": "No" },

            ],

            rewardType: [
                { "id": "FIXED", "text": "Set amount (eg £10)" },
                { "id": "PERCENTAGE", "text": "Percentage (eg 5%)" },
                { "id": "PERCENTAGE_MAX", "text": "Percentage with a Max Fixed value (eg 2% up to £10)" },


            ],

            customerType: [
                { "id": "EXISTING_CUSTOMER", "text": "All customers" },
                { "id": "NEW_CUSTOMER", "text": "New customers" }
            ],
            offerUsageType: [
                { "id": "SINGLEUSE", "text": "Single use" },
                { "id": "MULTIUSE", "text": "Multi use" }
            ],

            offerCondition: [
                { "id": "GREATER_THAN", "text": "Greater than" },
                { "id": "LESS_THAN", "text": "Less than" },
                { "id": "BETWEEN", "text": "Between" }

            ],

            fixedType: [
                { "id": true, "text": "Fixed" },
                { "id": false, "text": "Set by publisher" }
            ],

            headersTable1: [
                { text: "Name", value: "channelName" },
                { text: "Website", value: "website" },
                { text: "Address", value: "address" },
                { text: "Postcode", value: "postcode" },

            ],

            displayChannels:[]
        }
    },
    created()
    {
        this.getDisplayChannels()
    },
    methods:{
        async getDisplayChannels(){
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/channels-by-id`, {
                    method: "POST",
                    body: JSON.stringify(this.offerInformationData.channels),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.displayChannels = object
                    this.loading = false
                }

            } catch {
                return
            }
        },
    },
    computed: {
        validForm() {
            for (var i = 0; i < this.offerRequest.cashbackRules.length; i++) {
                var element = this.offerRequest.cashbackRules[i]
                if (element.customerType == "") {
                    return false
                }
                for (var j = 0; j < element.conditions.length; j++) {
                    var condition = element.conditions[j]
                    if (condition.type == "" || condition.fixedDistributorCommission == undefined || condition.value.type == "" || condition.value.totalValue == undefined) {
                        return false;
                    }
                    if (condition.type == "GREATER_THAN") {
                        if (condition.lowerBound == null) {
                            return false;
                        }
                    }
                    if (condition.type == "LESS_THAN") {
                        if (condition.upperBound == null) {
                            return false;
                        }
                    }
                    if (condition.type == "BETWEEN") {
                        if (condition.upperBound == null || condition.upperBound == null) {
                            return false;
                        }
                    }

                    if (condition.fixedDistributorCommission) {
                        if (condition.value.endUserValue == undefined || condition.value.supplierValue == undefined || condition.value.boogiValue == undefined || condition.value.clientValue == undefined) {
                            return false
                        }
                    }

                }
            }
            return true

        }
    }


}
</script>